import {
  Factory,
  NameValue,
  StandardEntity,
} from '@infodata-group/inf-commons';
import { AccountParameters } from '../account-parameters';
import { Communication } from '../communication';
import { Devise } from '../devise';
import { Exercise } from '../exercise';
import { Journal } from '../journal';
import { Country } from '../country';
import { VAT } from '../vat';

export class AccountParametersFactory implements Factory<AccountParameters> {
  public account: StandardEntity;

  constructor(account: StandardEntity) {
    this.account = account;
  }

  getApi(): string {
    if (this.account) {
      return `dos/${this.account.getId()}/detail`;
    }
  }

  build(o: any): AccountParameters {
    const params = new AccountParameters();
    params.activity = o.Activity;
    params.addressLand = o.AddressLand;
    params.addressLocality = o.AddressLocality;
    params.addressNum = o.AddressNum;
    params.addressPostCode = o.AddressPostCode;
    params.addressRegion = o.AddressRegion;
    params.addressStreet = o.AddressStreet;
    params.addressStreet2 = o.AddressStreet2;
    params.analytic = o.Analytique;
    params.code = o.Code;
    const communication = new Communication();
    for (const com of o.Communication) {
      params.communication.push(communication.convert(com));
    }
    params.contact = o.Contact;
    for (const del of o.Delais) {
      params.delays.push(new NameValue(del.Code, del.Label));
    }
    const devise = new Devise();
    for (const dev of o.Devises) {
      params.devises.push(devise.convert(dev));
    }
    const exercise = new Exercise();
    for (const ex of o.Exercices) {
      params.exercises.push(exercise.convert(ex));
    }
    const journal = new Journal();
    for (const j of o.Journaux) {
      params.journals.push(journal.convert(j));
    }
    params.label = o.Label;
    params.language = o.Language;
    for (const l of o.Langues) {
      params.languages.push(new NameValue(l.Code, l.Label));
    }
    params.registrationNumber = o.Matricule;
    params.parities = o.Parites;

    const country = new Country('', '');
    for (const p of o.Pays) {
      params.countries.push(country.convert(p));
    }

    params.rcNum = o.RcNum;

    params.societyType.name = o.SocietyType?.Id;
    params.societyType.value = o.SocietyType?.Label;

    const vat = new VAT();
    for (const v of o.TVA) {
      params.vat.push(vat.convert(v));
    }
    params.taxationOffice = o.TaxationOffice;
    params.title = o.Title;
    params.vatId = o.TvaId;
    params.vatCountry = o.TvaPays;
    params.accountLength = o.LongCompte;
    return params;
  }
}
